import { A4FormatContent_1, A4FormatContent_2, A4FormatContent_3, A4FormatContent_4 } from './styles';

export const designMap = [A4FormatContent_1, A4FormatContent_2, A4FormatContent_3, A4FormatContent_4];

export const BLOCK_CLASS_NAME = 'block';
export const COVER_ELEMENT_DATA_CLASS = 'cover';
export const UPFRONT_SUMMARY_DATA_CLASS = 'upfront-summary';
export const SECTION_CLASS_NAME = 'section';
